import React from 'react'
import ContactUsCard from '../components/commenComponents/ContactUsCard'
import HelmetComponent from './HelmetComponent';
function ContactUs(props) {
  return (
    <div className=' min-h-screen flex flex-col justify-between'>
      <HelmetComponent
        title="Akerayu | Need Help? Contact Our Support Team"
        description="Need assistance with Akerayu? Reach out to our friendly support team via our contact page."
        type="website"
        robots="index, follow"
        imageUrl="https://akerayu.com/emailImages/logo.png"
        pageUrl="https://akerayu.com/contact-us"
      />

        <div className='w-7/12 max-sm:w-full m-auto'>
            <ContactUsCard />
        </div>
    </div>
  )
}

export default ContactUs
